import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { addAppInCurrentUserSpaceQueryData, useAddAppInCurrentUserSpaceMutation } from '@query';

import { OpenableApp } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { setSpaceAppsInLocalStorage } from './SpacesAppListTabPanel';

export const useAddAppInSpaces = () => {
  const { isAuth } = useAuth();
  const { mutateAsync: addApp } = useAddAppInCurrentUserSpaceMutation();
  const queryClient = useQueryClient();

  return useCallback(
    async (openableApp: OpenableApp) => {
      if (isAuth) {
        await addApp(openableApp);
      } else {
        setSpaceAppsInLocalStorage(addAppInCurrentUserSpaceQueryData(queryClient, openableApp));
      }
    },
    [isAuth, addApp, queryClient],
  );
};
